import BtnSwitch from "../Button/BtnSwitch";
import stylesSwitch from "../Button/BtnSwitch.module.css";
import styles from "./ReactTableBase.module.css";
import React from "react";

const RenderCellActif = ({ value, row, putActifOpenModal }) => {
    return value ? <span className={styles.actifPill} style={{backgroundColor: "var(--clr-accent)"}}>Créé</span> :
        <span className={styles.actifPill} style={{backgroundColor: "var(--clr-danger)"}}>Supprimé</span>;

    if (putActifOpenModal === null) return value ? "Créé" : "Supprimé";
    return <BtnSwitch active={value} onToggle={() => putActifOpenModal(row.original)} activeLabel={"Créé"} inactiveLabel={"Supprimé"} classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>;
}


export default RenderCellActif;